<template>
    <div class="tab-container">
        <!-- 未展开模式：水平滚动 -->
        <div v-if="!isExpanded" ref="tabWrapper" class="tab-wrapper notScroll">
            <div v-for="(tab, index) in tabs" :key="index" class="tab-item" :class="{ active: activeIndex === index }"
                @click="handleTabClick(index,tab)" ref="tabItems">
                <div class="tabImg">
                    <img :src="tab.path" alt="" srcset="">
                </div>
                <div class="tabTxt">
                    {{ tab.name }}
                </div>
            </div>
            <div class="more-button" @click="toggleExpand">
                <img class="img" src="@/assets/images/common/openTxt.png" alt="" srcset="">
            </div>

        </div>

        <!-- 展开模式：平铺显示 -->
        <div v-else class="expanded-wrapper">
            <div class="grid-container">
                <div v-for="(tab, index) in tabs" :key="index" class="tab-item" :class="{ active: activeIndex === index }"
                    @click="handleTabClick(index,tab)">
                    <div class="tabImg">
                        <img :src="tab.path" alt="" srcset="">
                    </div>
                    <div class="tabTxt">
                        {{ tab.name }}
                    </div>
                </div>
            </div>
            <div class="collapse-btn" @click="toggleExpand">
                <span class="btn">收起</span>
                <img class="dropImg" src="@/assets/images/common/arrow_drop_down.png" alt="" srcset="">
            </div>
        </div>

    </div>
</template>
  
<script>
export default {
    props: {
        tabs: {
            type: Array,
            default: () => [],
        },
        updateActiveIndex: {
            type: Number,
            default: 0
        }
    },
    watch: {
        //     updateActiveIndex: {
        //   handler(newVal) {
        //     this.activeIndex = newVal;
        //     console.log('User changed:', newVal);
        //   },
        //   deep: true
        // }
        // updateActiveIndex(newVal){

        //     console.log('"newVal" ---:',newVal);

        // }
    },
    data() {
        return {
            activeIndex: 0, // 当前选中的索引
            isExpanded: false, // 是否处于展开模式
        };
    },
    methods: {
        // 点击选项卡
        handleTabClick(index,tab) {
            this.activeIndex = index;
            this.$emit("choseTabItemCb", { index: this.activeIndex,tab:tab });
            if (this.isExpanded) {
                this.toggleExpand();
            }
            this.$nextTick(() => {
                this.handleScroll(); // 滚动到对应位置
            })

        },
        setIndex(newVal) {
            this.activeIndex = newVal;
        },
        // 滚动处理
        handleScroll() {
            const tabWrapper = this.$refs.tabWrapper;
            const tabItems = this.$refs.tabItems;
            const wrapperWidth = tabWrapper.offsetWidth;

            let scrollLeft = tabWrapper.scrollLeft; // 当前滚动位置
            let currentTab = tabItems[this.activeIndex];
            const moreWidth = 40;
            if (currentTab) {
                const currentLeft = currentTab.offsetLeft;
                const currentRight = currentTab.offsetLeft + currentTab.offsetWidth;

                // 检查是否需要提前滚动两格
                if (currentLeft < (scrollLeft + tabItems[0].offsetWidth * 2) + moreWidth) {
                    // 靠近左边，向左滚动
                    tabWrapper.scrollTo({
                        left: Math.max(0, currentLeft - tabItems[0].offsetWidth * 2),
                        behavior: "smooth",
                    });
                } else if (
                    currentRight >
                    (scrollLeft + wrapperWidth - tabItems[0].offsetWidth * 2) - moreWidth
                ) {
                    // 靠近右边，向右滚动
                    tabWrapper.scrollTo({
                        left: Math.min(
                            tabWrapper.scrollWidth,
                            currentRight - wrapperWidth + tabItems[0].offsetWidth * 2
                        ),
                        behavior: "smooth",
                    });
                }
            }
        },
        // 切换展开/收起模式
        toggleExpand() {
            this.isExpanded = !this.isExpanded;
            this.$emit('showMask');
        },
    },
};
</script>
  
<style lang="less" scoped>
.headerBox {
    background-color: #ffffff;
}

/* 容器样式 */
.tab-container {
    width: 100%;
    position: relative;
    margin-top: 12px;
    z-index: 2;
}

/* 水平滚动模式 */
.tab-wrapper {
    display: flex;
    overflow-x: auto;
    white-space: nowrap;
    align-items: center;
    padding-bottom: 10px;
    height: 92px;
    width: 335px;
}



.tab-item {
    flex: 0 0 calc(25%);
    /* 宽度固定为容器宽度的四分之一 */
    padding: 0 8px;
    text-align: center;
    cursor: pointer;
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    height: 100%;

    .tabImg {
        width: 44px;
        height: 44px;
        border-radius: 50%;
        margin-bottom: 8px;
        border: 2px solid #E5E5E5;
        img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
        }
    }
}

.tabTxt {
    font-size: 14px;
    color: #9f9f9f;
}

.underLine {
    border-bottom: 2px solid #0059a3;
}

.tab-item.active {
    color: #0059a3;
    font-weight: bold;
}

.tab-item.active .tabImg  {
    border: 2px solid #0059a3;
}

.tab-item.active .tabTxt {
    color: #0059a3;
}

.more-button {
    position: absolute;
    right: 0;
    flex-shrink: 0;
    width: 44px;
    height: 92px;
    color: #fff;
    border: none;
    cursor: pointer;
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;

    img {
        width: 100%;
        height: 100%;
    }

    .btnTxt {
        font-size: 12px;
        color: #9F9F9F;
        line-height: 18px;
        text-align: center;
        width: auto;
        writing-mode: vertical-rl;
        text-align: center;
        letter-spacing: 2px;
    }


}

// .more-button::before {
//     content: '';
//     position: absolute;
//     top: 0;
//     left: 0;
//     bottom: 0;
//     width: 4px;
//     /* 阴影宽度 */
//     box-shadow: -2px 0 4px rgba(0, 0, 0, 0.1);
//     /* 左侧阴影 */
//     pointer-events: none;
//     /* 避免干扰点击事件 */
// }

/* 平铺展开模式 */
.expanded-wrapper {
    z-index: 3;
    position: relative;
    display: block;

    border-radius: 0 0 5px 5px;

    .collapse-btn {
        width: 100%;
        height: 42px;
        border-top: 1px solid #E5E5E5;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 0 0 5px 5px;

        .btn {
            font-size: 12px;
            color: #5D5D61;
            line-height: 18px;
            text-align: center;
        }

        .dropImg {
            transform: rotate(180deg);
            width: 18px;
            height: 18px;
        }
    }
}

.grid-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
    /* 自适应网格 */
    gap: 10px;
    padding: 10px;
}

.grid-item {
    padding: 10px;
    background-color: #f4f4f4;
    text-align: center;
    cursor: pointer;
    border-radius: 4px;
    border: 1px solid #ddd;

    .tabImg {
        width: 44px;
        height: 44px;
        border-radius: 50%;
        margin-bottom: 8px;

        img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
        }
    }
}

.grid-item.active {
    background-color: #0059a3;
    color: #fff;
}

.collapse-button {
    display: block;
    margin: 10px auto;
    padding: 8px 16px;
    background-color: #0059a3;
    color: #fff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}
</style>